import React from 'react';
import ShopPage from './ShopPage';
import './ShopPage.css';

const ShopPageMisc = () => {
  return <ShopPage collectionName="shopItemsMisc-v2" />;
};

export default ShopPageMisc;
